import * as React from 'react';

export const SingleItem = ({ item }: any) => {
    return (
        <>
            <div className='item'>
                <img src={item.imgUrl} />
            </div>
            <div className='item-desc'>
                <div>
                    <div className='title'>{item.productName}</div>
                    <div>{item.productDesc}</div>
                </div>
                <div className='price'>
                    {item.prize && item.prize.toString().split('.')[1] ? <>{item.prize.toString().split('.')[0]}<span className='upper-text'>,{item.prize.toString().split('.')[1]}</span></> : <>{item.prize},-</>}
                </div>
            </div>
        </>
    )
}
